"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable react/no-danger */
var clsx_1 = __importDefault(require("clsx"));
var react_1 = __importStar(require("react"));
var sanitize_html_1 = __importDefault(require("sanitize-html"));
var sanitizeUtils_1 = require("../Htmlizer/sanitizeUtils");
var bodyLineHeight = 20;
function ExtendableText(_a) {
    var contentBody = _a.contentBody, _b = _a.numberOfLinesToShow, numberOfLinesToShow = _b === void 0 ? 3 : _b;
    var hiddenBodyRef = (0, react_1.useRef)(null);
    var _c = __read((0, react_1.useState)(0), 2), hiddenBodyHeight = _c[0], setHiddenBodyHeight = _c[1];
    var _d = __read((0, react_1.useState)(false), 2), isBodyExtended = _d[0], setIsBodyExtended = _d[1];
    var inExtendableMode = hiddenBodyHeight > numberOfLinesToShow * bodyLineHeight;
    var contentBodyWithoutLessSign = (0, sanitizeUtils_1.replaceLessThanSignWithHtmlEntity)(contentBody);
    var sanitizedContentBody = (0, sanitize_html_1.default)(contentBodyWithoutLessSign, {
        allowedTags: ['span'],
        allowedClasses: {
            span: ['highlight-filter-match'],
        },
    });
    // to set the height before before the browser repaints the screen
    (0, react_1.useLayoutEffect)(function () {
        var _a, _b;
        if (!((_a = hiddenBodyRef === null || hiddenBodyRef === void 0 ? void 0 : hiddenBodyRef.current) === null || _a === void 0 ? void 0 : _a.offsetHeight)) {
            return;
        }
        setHiddenBodyHeight((_b = hiddenBodyRef === null || hiddenBodyRef === void 0 ? void 0 : hiddenBodyRef.current) === null || _b === void 0 ? void 0 : _b.offsetHeight);
        // to make sure that hiddenBodyHeight is updated
    }, []);
    (0, react_1.useEffect)(function () {
        setTimeout(function () {
            var _a;
            // to prevent having space related hiddenBodyRef under the main content
            (_a = hiddenBodyRef === null || hiddenBodyRef === void 0 ? void 0 : hiddenBodyRef.current) === null || _a === void 0 ? void 0 : _a.remove();
        }, 1000);
    }, []);
    return (react_1.default.createElement("div", { onClick: function () { return inExtendableMode && setIsBodyExtended(!isBodyExtended); }, className: (0, clsx_1.default)('eva-extendable-text', { 'eva-extendable-text--has-show-more-link': inExtendableMode }) },
        react_1.default.createElement("div", { className: (0, clsx_1.default)('eva-extendable-text__content', { 'is-body-extended': isBodyExtended }), dangerouslySetInnerHTML: { __html: sanitizedContentBody } }),
        react_1.default.createElement("div", { className: "eva-extendable-text__hidden-content", dangerouslySetInnerHTML: { __html: sanitizedContentBody }, ref: hiddenBodyRef }),
        react_1.default.createElement("div", { className: "eva-extendable-text__control-icon-container" },
            !isBodyExtended && react_1.default.createElement("span", { className: "eva-extendable-text__read-more-icon implioicons-arrow-2-down" }),
            isBodyExtended && react_1.default.createElement("span", { className: "eva-extendable-text__read-less-icon implioicons-arrow-2-up" }))));
}
exports.default = ExtendableText;
